export default __webpack_public_path__ + "static/media/error-icon-only.9bd1c2bf.svg";